/**
 * @module app.um
 */

import { autoinject } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { bindable } from 'aurelia-typed-observable-plugin';
import * as UM from 'app/um/models/essette-api'

@autoinject()
export class PreferredContactDisplay extends ComponentBase {

    ////****************** Fields and Properties **************************************////
    @bindable.objectNull
    protected preferredContact: UM.AuthPreferredContact | null = null;

    @bindable.boolean
    protected hideEmptyFields: boolean = true;

    ////****************** Element References ***************************************////


    ////****************** Lifecycle events (in order of execution) ******************////
    constructor(
        ...rest: any[]) {
        super(...rest);
    }

    ////****************** Events ***********************************************////
    protected preferredContactChanged() {
        if(this.preferredContact?.phone?.number && !this.preferredContact.phone.display) {
            this.preferredContact.phone.display = this.formatPhoneNumber(this.preferredContact.phone.number, this.preferredContact.phone?.extension);
        }

        if(this.preferredContact?.fax?.number && !this.preferredContact.fax.display) {
            this.preferredContact.fax.display = this.formatPhoneNumber(this.preferredContact.fax.number, this.preferredContact.fax?.extension);
        }
    }


    ////****************** Functions ***********************************************////
    // TODO: Replace this with a proper formatter in the format provider once we have a better idea of all the different phone number formats we need to support/display
    protected formatPhoneNumber(phone: string, extension?: string | null): string {
        const digits = phone.replace(/\D/g, '');
        let returnValue = '';

        returnValue = `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
        if(!!extension) {
            const extDigits = extension.replace(/\D/g, '');
            returnValue += ` x${extDigits}`;
        }

        return returnValue;
    }

}
